//--------------------------------------------------------------------------
// <copyright file="PairingAuthorizationFailedDialog.js" company="Microsoft">
// Copyright (c) Microsoft Corporation. All rights reserved.
// </copyright>
//--------------------------------------------------------------------------
import FluentPrimaryButton from './FluentPrimaryButton';
import MicrosoftLogo from './MicrosoftLogo';
import BackButton from './BackButton';
import PairingStates from "../models/PairingStatesEnum";

/// <summary>
/// Helper methods and display components related to Pairing In Progress dialog.
/// </summary>
const PairingAuthorizationFailedDialog = ({username, setPairingState, setHardwareId, hardwareId, logout, errorMessages, setSelectedOption}) => { 
  const pairAnotherDevice = () => {
    setHardwareId('');
    setSelectedOption(null);
    setPairingState(PairingStates.PairingCodeNotEntered);
  }

  const bulletPoints = errorMessages.map((item, index) => (
    <li role="alert" key={index}>{item}</li>
  ));


  return (
    <div className="Dialog-hardwareid">
      <MicrosoftLogo/>
      <BackButton onClickFunction={logout}/>
      <p role="alert" data-testid="message-header" className="Dialog-paragraph-authorization" >Authorization failed.<br/>Please fix the following issues and try again:</p>
      <p data-testid="message" className="Dialog-authorization-error display-linebreak">{bulletPoints}</p>
      <p data-testid="username" className="Dialog-username">{username}</p>
      <a className="Dialog-authorization-failure" rel="noreferrer noopener" target="_blank" href="https://feedbackportal.microsoft.com/feedback/">Give feedback</a>
      <FluentPrimaryButton text = 'Retry pair' cssClassName = 'Dialog-button-retry' onClickFunction = {pairAnotherDevice}/>
    </div>
  )
}

export default PairingAuthorizationFailedDialog
